import { isProxyByCode, proxyCodesByCode } from '@/services/municipalities'
import { fetchCompressedData } from '@/helpers/api'
import { mapMutations, mapGetters } from 'vuex'
import { Bugfender } from '@bugfender/sdk'
import Vue from 'vue'

export default {
  data() {
    return {
      isDbOccupied: false,
      allChargingpoints: [],
      allCPOS: [],
    }
  },
  computed: {
    ...mapGetters('planmode', ['getChargingPoints']),
    ...mapGetters('access', ['getCPOS']),

  },
  methods: {
    ...mapMutations('planmode', [
      'setChargingPoints',
    ]),
    ...mapMutations('access', [
      'setActiveCPOS',
    ]),
    async $_chargingpointsLoadMixin_getChargingPointsByCodes({ code, codes, token, after }) {
      if (!after) {
        this.allChargingpoints = []
      }

      const api = await fetch('/api/chargingpointsload', {
        method: 'POST',
        headers: {
          authorization: 'Bearer ' + token,
        },
        body: JSON.stringify({ after, codes, code }),
      })

      if (!api.ok) {
        return Vue.notify({
          type: 'error',
          title: 'Er is iets misgegaan!',
          text: 'De locaties konden niet worden geladen',
        })
      }

      const response = await api.json()
      this.allCPOS = [
        ...this.allCPOS,
        ...response.cpos.filter(
          cpo => !this.allCPOS.some(existing => existing.uuid === cpo.uuid),
        ),
      ]

      this.allChargingpoints = [...this.allChargingpoints, ...response.chargingpoints]

      if (response.after) {
        return await this.$_chargingpointsLoadMixin_getChargingPointsByCodes({ code, codes, token, after: response.after })
      }

      this.setChargingPoints({ chargingpoints: this.allChargingpoints })
      this.setActiveCPOS({ activeCPOS: this.allCPOS })

      this.allCPOS=[]
      this.isDbOccupied = false
      this.$store.dispatch('planmode/setLoadingState', { value: true })
    },

    async $_chargingpointsLoadMixin_getChargingPointsByCodeStatus({ code, statuses }) {
      const token = await this.$auth.getTokenSilently()

      const fetchForStatus = async (status) => {
        try {
          const response = await fetchCompressedData('/api/chargingpoints-by-code-status', {
            method: 'POST',
            headers: { authorization: 'Bearer ' + token },
            body: JSON.stringify({ code, status }),
          })
          return response.records || []
        } catch (error) {
          Bugfender.error('$_chargingpointsLoadMixin_getChargingPointsByCodeStatus: ', error)
          Vue.notify({
            type: 'error',
            title: 'Er is iets misgegaan!',
            text: `De locaties voor status ${status} konden niet worden geladen`,
          })
          return []
        }
      }

      const results = await Promise.allSettled(statuses.map(fetchForStatus))

      return results
        .filter(result => result.status === 'fulfilled')
        .flatMap(result => result.value)
    },

    /**
     * Load the charging points for a municipality by code
     */
    async $_chargingpointsLoadMixin_loadChargingPoints({ code }) {
      if (this.getChargingPoints.length && this.getChargingPoints[0].code === code) {
        return this.getChargingPoints
      }

      this.isDbOccupied = true
      this.$store.dispatch('planmode/setLoadingState', { value: false })

      let codes = [code]
      if (isProxyByCode({ code })) {
        codes = proxyCodesByCode({ code })
      }

      const token = await this.$auth.getTokenSilently()
      await this.$_chargingpointsLoadMixin_getChargingPointsByCodes({ code, codes, token })

      return this.getChargingPoints
    },
    /**
     * Check if specific import source exists within given municipality ()
     */
    async chargingpointsBySource({ code, source }) {
      const token = await this.$auth.getTokenSilently()
      const api = await fetch('/api/chargingpoints_by_source', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ code, source }),
      })
      const tp = await api.json()
      return api.ok && !!tp
    },
  },
}
